<div class="flex gap-4">
  <mat-icon class="flex-shrink-0">{{ icon }}</mat-icon>
  <div class="snack-content gap-2">
    <span matSnackBarAction>{{ data.title }}</span>
    @if (data.description) {
      <span class="snack-description">{{ data.description }}</span>
    }
    @if (data.action) {
      <div class="flex justify-end w-full">
        <button
          matButton="outlined"
          [color]="actionColor"
          class="btn-xs"
          (click)="snackBarRef.dismissWithAction()"
        >
          {{ data.action }}
        </button>
      </div>
    }
  </div>
</div>
